import KoobTabs from '@koob/ui/src/components/KoobTabs';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ToConnectionRequestBulkEdit from '../BulkEdit';
import ToConnectionRequestModels from '../Models';
import ToConnectionRequestPromotions from '../Promotions';

const TAB = {
  BULK_EDIT: 'bulk-edit',
  MODELS: 'models',
  PROMOTIONS: 'promotions',
};

const BulkEditTabs = () => {
  const { t } = useTranslation('toConnectionRequest', {
    keyPrefix: 'bulkEditTabs',
  });
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = location.pathname.endsWith(TAB.MODELS)
    ? TAB.MODELS
    : location.pathname.endsWith(TAB.PROMOTIONS)
      ? TAB.PROMOTIONS
      : TAB.BULK_EDIT;

  const setCurrentTab = (tab) => {
    navigate(`/to-connection-request/${tab}`);
  };

  const tabs = [
    {
      id: TAB.BULK_EDIT,
      label: t('bulkEdit'),
    },
    {
      id: TAB.MODELS,
      label: t('DistributionModels'),
    },
    {
      id: TAB.PROMOTIONS,
      label: t('promotions'),
    },
  ];

  return (
    <div className="my-6 py-4">
      <KoobTabs
        tabs={tabs}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
      {currentTab === TAB.BULK_EDIT && <ToConnectionRequestBulkEdit />}
      {currentTab === TAB.MODELS && <ToConnectionRequestModels />}
      {currentTab === TAB.PROMOTIONS && <ToConnectionRequestPromotions />}
    </div>
  );
};

export default BulkEditTabs;
